import React, { useState, useEffect, useMemo } from 'react';
import { Typography } from 'antd';
import dayjs from 'dayjs';
import CrudPage from '../../../components/common/CrudPage';
import { fileService, contentCategoryService } from '../../../services/cms/contentManagementService';

const { Text } = Typography;

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 60 },
  { title: 'TÊN FILE', dataIndex: 'title', key: 'title', render: (t) => <Text strong>{t}</Text> },
  { title: 'DANH MỤC', dataIndex: 'category_id', key: 'category_id', width: 150, render: (val, r) => r.category_name ? `[${val}] ${r.category_name}` : (val || '-') },
  { title: 'NGƯỜI TẠO', dataIndex: 'author_name', key: 'author_name', width: 140, render: (val, r) => val || r.create_by || r.created_by || '-' },
  { title: 'THUMB', dataIndex: 'thumb', key: 'thumb', width: 80, render: (u) => u ? <img src={u} alt="" style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4 }} /> : '-' },
  // CMS cũ hiện thẳng đường dẫn file (Files::getLink) chứ không phải chữ "Mở" — giữ nguyên
  // hành vi đó để copy link nhanh, vẫn bấm được vì bọc trong thẻ <a>.
  {
    title: 'LINK',
    dataIndex: 'link',
    key: 'link',
    width: 320,
    ellipsis: true,
    render: (l) => (l ? <a href={l} target="_blank" rel="noreferrer" title={l}>{l}</a> : '-'),
  },
  { title: 'NGÀY TẠO', dataIndex: 'created_at', key: 'created_at', width: 140, render: (t) => t ? dayjs(t).format('DD/MM/YYYY HH:mm') : '-' },
];

const QuanLyFile = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    contentCategoryService.listActive().then((res) => {
      if (Array.isArray(res)) {
        setCategories(res.map((c) => ({ label: `[${c.id}] ${c.title}`, value: c.id })));
      }
    });
  }, []);

  const formFields = useMemo(() => [
    { name: 'title', label: 'Tên file', type: 'input', rules: [{ required: true, message: 'Vui lòng nhập tên!' }] },
    { name: 'category_id', label: 'Danh mục', type: 'select', options: categories, propsInput: { showSearch: true } },
    { name: 'description', label: 'Mô tả', type: 'textarea' },
    { name: 'thumb', label: 'Ảnh thumbnail', type: 'upload-cdn' },
    { name: 'link', label: 'Link file', type: 'upload-file', placeholder: 'Nhập link hoặc bấm Upload để tải file lên', uploadFolder: 'lichviet', maxSizeMB: 50, rules: [{ required: true, message: 'Vui lòng nhập hoặc upload link file!' }] },
  ], [categories]);

  const filterFields = useMemo(() => [
    {
      label: 'Chọn danh mục',
      value: 'category_id',
      options: [{ label: 'Tất cả danh mục', value: '' }, ...categories],
    },
  ], [categories]);

  return (
    <CrudPage
      title="QUẢN LÝ FILE"
      subTitle="Quản lý file upload"
      itemsName="File"
      queryKey="fileList"
      service={fileService}
      columns={columns}
      formFields={formFields}
      filterFields={filterFields}
      searchPlaceholder="Tìm kiếm..."
      addButtonLabel="Thêm file"
    />
  );
};

export default QuanLyFile;
